// extracted by css-extract-rspack-plugin
export default {"TagJumpTo":"r3puU","TagJumpToInner":"zYl6R","TagJumpToSelectRoot":"VYhuN","TagJumpToInput":"h5INd","TagSection":"lXhT8"};